export default "__VITE_ASSET__HSnjX09s__"